import { getClient } from "services";

import {
  makeFetchMyPremiumTrials,
  makeFetchMyPremiumTrialsIfNotFetched
} from "./fetchMyTrial";
import {
  makeRecordTrialEvent,
  makeRecordWrongAnswersSessionStudy,
  makeRecordWrongAnswersSessionStudyIfNeeded
} from "./recordTrialEvent";
import {
  makeStartInviteParentsExamQuestionsPremiumTrial,
  makeStartPremiumTrial
} from "./startPremiumTrial";

const getTrialsServiceClient = () => getClient("trialsService");

// fetch premium trials
export const fetchMyPremiumTrials = makeFetchMyPremiumTrials(
  getTrialsServiceClient
);
export const fetchMyPremiumTrialsIfNotFetched =
  makeFetchMyPremiumTrialsIfNotFetched(getTrialsServiceClient);

// start premium trial
export const startPremiumTrial = makeStartPremiumTrial(getTrialsServiceClient);

export const startInviteParentsExamQuestionsPremiumTrial =
  makeStartInviteParentsExamQuestionsPremiumTrial(getTrialsServiceClient);

// record trial event
export const recordTrialEvent = makeRecordTrialEvent(getTrialsServiceClient);
export const recordWrongAnswersSessionStudy =
  makeRecordWrongAnswersSessionStudy(getTrialsServiceClient);
export const recordWrongAnswersSessionStudyIfNeeded =
  makeRecordWrongAnswersSessionStudyIfNeeded(getTrialsServiceClient);
